import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { TranslatableSnackBarService } from "@obg/mat.ui.core";
import { AUTH_ACTION_TYPE } from "@obg/ngx.core";
import { tap } from "rxjs/operators";

import { SESSION_EXPIRED_ALERT_ID } from "./session-expired-alert.const";

@Injectable()
export class SessionExpiredAlertEffect {
	constructor(
		private actions$: Actions,
		private translatableSnackBarService: TranslatableSnackBarService
	) {}

	sessionStart$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AUTH_ACTION_TYPE.sessionStart),
				tap(() => {
					if (this.translatableSnackBarService.getSnackbarId() === SESSION_EXPIRED_ALERT_ID) {
						this.translatableSnackBarService.dismissSnackBar();
					}
				})
			),
		{ dispatch: false }
	);
}
